/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import monitoringService from 'infrastructure/serviceHandlers/Monitoring/Monitoring';
import { getBirdPlans } from 'services/api/birdApi';
import { TPlanList } from 'typings';
import { TBirdPlanState } from 'typings/birdTypes';

export const fetchBirdPlans = createAsyncThunk(
  'spaces/fetchBirdPlans',
  async (payload: string, thunkAPI) => {
    try {
      const response = await getBirdPlans(payload);
      return response.data;
    } catch (error) {
      monitoringService.captureException(error, {
        tags: {
          feature: 'fetchBirdPlans',
          error_type: 'api_error'
        },
        extra: {
          payload
        }
      });
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialPlanState: TBirdPlanState = {
  birdPlanList: [],
  isLoading: false
};

export const allPlanSlice = createSlice({
  name: 'allPlans',
  initialState: initialPlanState,
  reducers: {
    clearBirdPlansData: (state) => {
      state.birdPlanList = [];
    },
    updateBirdPlansData: (state, action) => {
      state.birdPlanList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBirdPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.birdPlanList = action.payload as TPlanList[];
      })
      .addCase(fetchBirdPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBirdPlans.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const { clearBirdPlansData, updateBirdPlansData } = allPlanSlice.actions;

export default allPlanSlice.reducer;
